import { LitElement, html, svg } from 'lit';

export class IconTableInfo16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>En sirkel med bokstaven I</title><circle cx="8" cy="8" r="5.25" stroke="currentColor" stroke-width="1.5"></circle><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 5.6v.6M8 8.5v1.9"></path></svg>`; }
}
if (!customElements.get('f-icon-table-info16', IconTableInfo16)) {
  customElements.define('f-icon-table-info16', IconTableInfo16);
}